import { useCallback } from 'react';
import { useLocalStorage } from '@shared/util/storage';

const FIXED_WIDTH_STORAGE_KEY = 'card-fixed-width';

export function useFixedWidth(
  key = FIXED_WIDTH_STORAGE_KEY,
  defaultValue = true,
): [boolean, VoidFunction] {
  const [isFixedWidth, setIsFixedWidth] = useLocalStorage(key, defaultValue);
  const toggleFixedWidth = useCallback(() => setIsFixedWidth(prev => !prev), [setIsFixedWidth]);
  return [isFixedWidth, toggleFixedWidth];
}
